import { IOfferScopeListTableLang } from '../../../types/lang'

export const offerScopeListTableLang: IOfferScopeListTableLang = {
	offer_scope_list_table: {
		column_id: 'ID_ru',
		column_name: 'Name_ru',
		column_offer_id: 'Offer ID_ru',
		column_notes: 'Notes_ru',
		column_affiliate_network: 'Affiliate Network_ru',
		column_country: 'Country_ru',
		column_sales_cap: 'Sales/Cap_ru',
		column_diff: 'Diff_ru',
		column_cap_type: 'Type_ru',
		column_status: 'Status_ru',
	}
}